import React from 'react'
import { CardContent, Box, Divider, Button } from '@mui/material'
import { connect } from '@cerebral/react'
import { props, sequences } from 'cerebral'
import CompactLayout from './elements/CompactLayout'
import Content from './elements/Content'
import { AnalyticsMetric, MetricAction } from '../../../types/Metrics'
import FlatCard from '../../elements/FlatCard'

type MetricActionDeps = {
  handleAction?: () => void
}

const MetricActionButton = connect<MetricAction, MetricActionDeps>(
  {
    handleAction: sequences`${props`sequence`}`,
  },

  ({ label, handleAction }: MetricAction & MetricActionDeps) => {
    if (!handleAction) {
      return null
    }

    return (
      <Box>
        <Divider sx={{ my: 1 }} />
        <Button color="primary" onClick={() => handleAction()} variant="text" size="small">
          {label}
        </Button>
      </Box>
    )
  }
)

type MetricCardProps = Omit<AnalyticsMetric, 'id'> & {
  compact?: boolean
}

const MetricCard = ({ compact = true, action = null, ...rest }: MetricCardProps) => {
  const displayCompact = compact && rest.detail
  const actionButton = action?.sequence ? <MetricActionButton sequence={action.sequence} label={action.label} /> : null

  return displayCompact ? (
    <CompactLayout compact={compact} {...rest}>
      {actionButton}
    </CompactLayout>
  ) : (
    <FlatCard>
      <CardContent>
        <Content compact={compact} actionComponent={actionButton} {...rest} />
      </CardContent>
    </FlatCard>
  )
}

export default MetricCard
